<div class="content">
  <form class="form" data-test-id="invite-create-password-form">
    <app-heading titleLevel="3">{{
      (isCurrentUser ? 'login.updateYourPassword' : 'login.createYourPassword')
        | translate
    }}</app-heading>
    <span
      class="description"
      data-test-id="invite-create-password-description"
      >{{
        (isCurrentUser
          ? 'login.updatePasswordReq'
          : 'login.setPasswordDescription'
        ) | translate
      }}</span
    >
    @if (isCurrentUser) {
    <app-input
      class="field"
      [inputValue]="currentPassword"
      type="password"
      placeholder="{{ 'common.enterCurrentPassword' | translate }}"
      [error]="passwordError"
      size="large"
      width="full"
      direction="vertical"
      [spacingBottom]="24"
      data-test-id="invite-create-password-current-password-input"
    ></app-input>
    }
    <app-input
      class="field"
      [inputValue]="password"
      type="password"
      placeholder="{{ 'common.enterNewPassword' | translate }}"
      [error]="passwordError"
      size="large"
      width="full"
      direction="vertical"
      [spacingBottom]="24"
      data-test-id="invite-create-password-password-input"
    ></app-input>
    <app-input
      class="field"
      [inputValue]="confirmPassword"
      type="password"
      placeholder="{{ 'common.confirmPassword' | translate }}"
      [error]="passwordError"
      errorMessage="{{ 'login.enterPassword' | translate }}"
      size="large"
      direction="vertical"
      width="full"
      [spacingBottom]="32"
      data-test-id="invite-create-password-confirm-password-input"
    ></app-input>
    <div class="check-container">
      <app-checkmark
        [checked]="passwordCriteria.lengthCheck()"
        text="{{ 'login.charsCheck' | translate }}"
        data-test-id="invite-create-password-length-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.uppercase()"
        text="{{ 'login.uppercaseCheck' | translate }}"
        data-test-id="invite-create-password-uppercase-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.lowercase()"
        text="{{ 'login.lowercaseCheck' | translate }}"
        data-test-id="invite-create-password-lowercase-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.number()"
        text="{{ 'login.numberCheck' | translate }}"
        data-test-id="invite-create-password-number-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.specialChar()"
        text="{{ 'login.specialCheck' | translate }}"
        data-test-id="invite-create-password-special-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.match()"
        text="{{ 'login.matchCheck' | translate }}"
        data-test-id="invite-create-password-match-check"
      ></app-checkmark>
    </div>
    <app-button
      type="primary"
      size="large"
      (handleClick)="onSubmit()"
      [disabled]="!isFormValid() || isLoading()"
      spacingBottom="24"
      data-test-id="invite-create-password-submit-button"
      >{{
        (isCurrentUser ? 'common.update' : 'login.setPassword') | translate
      }}</app-button
    >
    <div class="existing-account-wrapper">
      <p data-test-id="invite-create-password-existing-account-text">
        {{ 'invite.existingAaptivAccount' | translate }}&nbsp;
      </p>
      <a
        routerLink="/login"
        [queryParams]="{
          'auth-code': authCode(),
          'auth-id': authId(),
          'tenant-id': tenantId()
        }"
        data-test-id="invite-create-password-login-link"
        >{{ 'invite.logInHere' | translate }}</a
      >
    </div>
  </form>
  <app-toast [position]="ToastPosition.FORM"></app-toast>
</div>
